import Vue from 'vue'
import App from './App.vue'
import AppStylistProfile from './AppStylistProfile.vue'
import store from './store'
import VueResource from "vue-resource"
import * as VueGoogleMaps from 'vue2-google-maps'
import ModalBooking from './components/ModalBooking.vue'

import VueLazyLoad from 'vue-lazyload'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')



Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(require('vue-moment'));
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD43WrsMyDAB2bnCSJD-DQLKolcuz748go',
    libraries: 'places'
  }
})

Vue.use(VueLazyLoad)


export const eventBus = new Vue();

var vue_page = document.getElementById("vue_page").value

if(vue_page=='stylist_archive') {
    new Vue({
      store,
      render: h => h(App)
    }).$mount('#vue-app-wrapper')
}

if(vue_page=='stylist_profile') {
    new Vue({
      store,
      render: h => h(AppStylistProfile)
    }).$mount('#vue-app-wrapper-stylist-profile')
}